// path: stores/stageFunctionalSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Stage } from "../types/stageTypes";

export type ManagementView = "stages" | "tracks";

export interface StageState {
  isDeleteModal: boolean;
  isCollapse: boolean;
  currentItem: Stage | null;
  currentItemTab: "Status" | "Choices" | "Requirements" | "Other";
  isAddStage: boolean;
  isEditStage: boolean;
  managementView: ManagementView;
}

const initialState: StageState = {
  isDeleteModal: false,
  isCollapse: false,
  isAddStage: false,
  isEditStage: false,
  currentItem: null,
  currentItemTab: "Status",
  managementView: "stages",
};

const stageFunctionalSlice = createSlice({
  name: "stageFunctional",
  initialState,
  reducers: {
    setIsDeleteModal(state, action: PayloadAction<boolean>) {
      state.isDeleteModal = action.payload;
    },
    setStageCurrentItem(state, action: PayloadAction<any>) {
      state.currentItem = action.payload;
    },
    setHandleStageCollapseToggle(state) {
      state.isCollapse = !state.isCollapse;
    },
    setStageCurrentTab(state, action) {
      state.currentItemTab = action.payload;
    },
    setToggleAddStage(state) {
      state.isAddStage = !state.isAddStage;
    },
    setToggleEditStage(state) {
      state.isEditStage = !state.isEditStage;
    },
    setManagementView(state, action: PayloadAction<ManagementView>) {
      state.managementView = action.payload;
    },
  },
});

export const {
  setIsDeleteModal,
  setStageCurrentItem,
  setHandleStageCollapseToggle,
  setStageCurrentTab,
  setToggleEditStage,
  setToggleAddStage,
  setManagementView,
} = stageFunctionalSlice.actions;
export default stageFunctionalSlice.reducer;
